import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import { Button } from "@Core/components/UI";

import { AssignmentInstance } from "@LNI/models";

type Props = {
  assignment: AssignmentInstance;
};

const Article = ({ assignment }: Props) => {
  const { t } = useTranslation();

  useEffect(() => {
    assignment.setCanComplete();
  }, [assignment]);

  const onSubmit = () => {
    toast.success(t(`ASSIGNMENT.${assignment.category}.COMPLETED`));
    assignment.setCompleted();
  };

  return (
    <div>
      <p>{t("ASSIGNMENT.ARTICLE.UNAVAILABLE")}</p>
      <div className="btn-row">
        <Button onClick={onSubmit} tertiary disabled={assignment.canFinish}>
          {t(`ASSIGNMENT.${assignment.category}.DONE`)}
        </Button>
      </div>
    </div>
  );
};

export default Article;
